module.exports = __webpack_public_path__ + "assets/deleteImg.07c7248e204b60398fec163d8058bcfb.png";